import { unstable_batchedUpdates } from 'react-dom';

/**
 * Runs `fn` as one React update, like a click handler does. The web app is mounted with the legacy renderer
 * (react-native-web 0.16), where state changes made after an await are rendered one by one - so a half-applied
 * state can be seen by effects in between (DEV 2026-10-11: the tutor started after the microphone check rendered
 * "tutor on, no session yet", an effect switched it back off, and the session then ran with the controls "off").
 */
export const batchUpdates = fn => unstable_batchedUpdates(fn);
